import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { BaseApiState } from '../models/api-model';

export function usePendingRequests(): boolean {
    const apiState = useSelector<TcsmStates, BaseApiState>(state => state.apiState);

    return apiState?.pendingRequests?.filter(request =>
        !request.includes('calculate_totals.json')
        && !request.includes('person/search')
        && !request.includes('search_employers.json')
        && !request.includes('enrollment/tiercalc')
        && !request.includes('terminations/')
        && !request.includes('/rules/group_life_rate.json')
        && !request.includes('benefit_end_dates')
        && !request.includes('api/v1/errorlogging')).length > 0;
}

